import React, { useEffect, useRef, useState } from 'react';

const SignalCard = ({ icon, text, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay);
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, [delay]);

  return (
    <div 
      ref={cardRef}
      className={`bg-amber-50 rounded-lg p-6 border border-amber-100 shadow-sm hover:shadow-md transition-all duration-300 transform ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
    >
      <div className="flex items-start gap-4">
        <div className="bg-white p-3 rounded-full shadow-sm">{icon}</div>
        <p className="text-gray-700">{text}</p>
      </div>
    </div>
  );
};

export default SignalCard;
